import { render } from "./goods_image_list.vue?vue&type=template&id=6575b5f2&scoped=true"
import script from "./goods_image_list.vue?vue&type=script&lang=js"
export * from "./goods_image_list.vue?vue&type=script&lang=js"

import "./goods_image_list.vue?vue&type=style&index=0&id=6575b5f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6575b5f2"]])

export default __exports__